var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-placeholders',{staticClass:"loading-placeholder",attrs:{"rounded":true}},[_c('content-placeholders-text',{attrs:{"lines":_vm.lines}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }